const routes = {
  indexPage: '/:lang/index',
  commercialPage: '/:lang/commercial/:filter?',
  commercialProjectPage: '/:lang/commercialProject/:project',
  artPage: '/:lang/art',
  artShowcasePage: '/:lang/art/:filter',
  aboutPage: '/:lang/about',
  experiencePage: '/:lang/experience',
  projectPage: '/:lang/project/:project?',
  // experiencePage: '/:lang/experience/:experience?',
  experienceDetailPage: '/:lang/event/:eventid',
  eventPage: '/:lang/event/:eventname',
  contactPage: '/:lang/contact',
  privacyPage: '/:lang/privacy',
  legalPage: '/:lang/legal',
  testPage: '/:lang/test',
  pageWithLang: (page, lang) => `/${lang}/${page}`,
  pageWithLangAndFilter: (page, lang, filter) => `/${lang}/${page}${filter? `/${filter}`: ''}`,
  pageWithLangAndProject: (page, lang, project) => `/${lang}/${page}${project? `/${project}`: ''}`
  // artPageWithLangAndFilter: (lang, project) => 
};

export default routes;